import React from 'react'
import Link from 'gatsby-link'
import Helmet from 'react-helmet'

import mapIcon from '../images/map-icon.png'

const Contacto = class Contacto extends React.Component {
    componentDidMount() {
        setTimeout(() => {
            try {
                // Google maps
                const mapLocation = new google.maps.LatLng(28.471811, -16.433345);

                const map = new GMaps({
                    streetViewControl: false,
                    overviewMapControl: false,
                    mapTypeControl: false,
                    panControl: false,
                    scrollwheel: true,
                    center: mapLocation,
                    el: '#map',
                    zoom: 15,
                    styles: [
                        {
                            "featureType": "landscape",
                            "stylers": [
                                { "saturation": -100 },
                                { "lightness": 65 },
                                { "visibility": "on" }
                            ]
                        },
                        {
                            "featureType": "poi",
                            "stylers": [
                                { "saturation": -100 },
                                { "lightness": 51 },
                                { "visibility": "simplified" }
                            ]
                        },
                        {
                            "featureType": "road.highway",
                            "stylers": [
                                { "saturation": -100 },
                                { "visibility": "simplified" }
                            ]
                        },
                        {
                            "featureType": "road.arterial",
                            "stylers": [
                                { "saturation": -100 },
                                { "lightness": 30 },
                                { "visibility": "on" }
                            ]
                        },
                        {
                            "featureType": "road.local",
                            "stylers": [
                                { "saturation": -100 },
                                { "lightness": 40 },
                                { "visibility": "on" }
                            ]
                        },
                        {
                            "featureType": "transit",
                            "stylers": [
                                { "saturation": -100 },
                                { "visibility": "simplified" }
                            ]
                        },
                        {
                            "featureType": "administrative.province",
                            "stylers": [
                                { "visibility": "off" }
                            ]
                        },
                        {
                            "featureType": "water",
                            "elementType": "labels",
                            "stylers": [
                                { "visibility": "on" },
                                { "lightness": -25 },
                                { "saturation": -100 }
                            ]
                        }
                    ]
                });

                map.addMarker({
                    position: mapLocation,
                    icon: mapIcon,
                });
            } catch (e) {}
        }, 500);
    }

    render() {
        return (
            <div style={{ marginBottom: '-120px' }}>
                <Helmet>
                    <title>Contacto</title>
                    <script type="text/javascript" src="https://maps.googleapis.com/maps/api/js?key=AIzaSyDlYNNs7VBO71qiKFMNiD0R9sd8hOt0wD4"></script>
                </Helmet>

                <div className="contact-us-map">
                    <div className="container">
                        <div className="location">
                            <h5>Dismocan</h5>
                            <p>Carretera local, 166. El Sauzal</p>
                            <p>695 54 74 36</p>
                            <p>info@dismocan.com</p>
                            <a className="btn btn-primary d-none d-sm-inline" href="https://www.google.com/maps?ll=28.471811,-16.433345&z=15&t=m&hl=en&gl=US&mapclient=apiv3">
                                Ver en google maps
                            </a>
                        </div>
                    </div>
                    <div id="map" style={{ 'height': 'calc(100vh - 91px - 73px)' }}></div>
                </div>
            </div>
        )
    }
}
        
export default Contacto



// WEBPACK FOOTER //
// ./src/pages/contacto.js